import { Component, OnInit, Input } from '@angular/core';
import { AffCodeService } from '../../affcode/shared/affcode.service';
import { AffCodeType } from '../../affcode/shared/affcode-type.model';
import { FormElementAffiliationCodeOption } from '../shared/model/affiliation-code/form-element-affiliation-code-option.model';
import { FormElementAffiliationCode } from '../shared/model/affiliation-code/form-element-affiliation-code.model';

@Component({
  selector: 'wl-form-builder-affiliation-checklist-edit-element',
  providers: [AffCodeService],
  templateUrl: 'form-builder-affiliation-checklist-edit-element.component.html',
    standalone: false
})
export class FormBuilderAffiliationChecklistEditElementComponent {
  public affCodeSettings: FormElementAffiliationCode;
  private _allFields: Array<FormElementAffiliationCodeOption>;
  public affCodeTypes: Array<AffCodeType>;

  public constructor(private _affCodeService: AffCodeService) {
    this.affCodeSettings = new FormElementAffiliationCode();
    //this._allFields = [];
    this.affCodeTypes = [];
  }

  ngOnInit(): void {
    this._affCodeService.getAllAffCodeTypesAndAffCodes().then((data) => {
      this.affCodeTypes = data.filter((x) => x.AffCodeType != '');
    });
  }

  // get any fields that might not already be in the array
  refetchAffCodes(): void {
    this._affCodeService.getAllAffCodeTypesAndAffCodes().then((data: any) => {
      this.affCodeTypes = data.filter((x: any) => x.AffCodeType != '');
      let affCodeType = this.affCodeTypes.filter((x) => x.AffCodeTypeID == this.affCodeSettings.AffCodeTypeId);

      if (affCodeType == null) {
        return;
      }
      this._allFields = affCodeType[0].AffCodes.filter((x) => x.AffCode != null).map(
        (x) =>
          <FormElementAffiliationCodeOption>{
            AffId: x.AffId,
            Name: x.Descr,
            Value: x.AffCode,
          }
      );

      // add any fields that aren't already in the array
      this._allFields.forEach((x: any) => {
        let foundField = this.affCodeSettings.AffCodeOptions.find((f) => {
          return f.AffId.toString() == x.AffId.toString();
        });
        if (foundField == null) this.affCodeSettings.AffCodeOptions.push(x);
      });

      this.affCodeSettings.AffCodeOptions = this.affCodeSettings.AffCodeOptions.sort((a, b) => {
        if (a.Name > b.Name) return 1;
        if (a.Name < b.Name) return -1;
        return 0;
      });
    });
  }

  public onAffCodeTypeChange(affCodeTypeId: any): void {
    this.affCodeSettings.AffCodeOptions = [];
    let affCodeType = this.affCodeTypes.filter((x) => x.AffCodeTypeID == affCodeTypeId);
    let fields = affCodeType[0].AffCodes.filter((x) => x.AffCode != null).map(
      (x) =>
        <FormElementAffiliationCodeOption>{
          AffId: x.AffId,
          Name: x.Descr,
          Value: x.AffCode,
        }
    );
    this.affCodeSettings.AffCodeOptions = fields;
  }
}
